import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

export const Title = () => {
  const isDesktop = useIsDesktop();
  return (
    <Stack color={'text.secondary'} gap={isDesktop ? '12px' : '8px'}>
      <Typography variant={'h2'} component='h1'>
        {Dictionary[DICTIONARY.PersonalDetails].title}
      </Typography>
      <Typography variant={'body3'}>
        {Dictionary[DICTIONARY.PersonalDetails].subTitle}
      </Typography>
    </Stack>
  );
};
